export type VerificationTokenType = 'PASSWORD_RECOVERY';

export const VerificationTokenTypeEnum = {
    PasswordRecovery: 'PASSWORD_RECOVERY' as VerificationTokenType,
};
